export default __webpack_public_path__ + "static/media/ndqn2.6bc74304.png";